// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.correspondenceContainer__mJ2ze {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  height: 100%;

  background-color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat/Correspondence/Correspondence.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;;EAE9B,YAAY;;EAEZ,uBAAuB;AACzB","sourcesContent":[".correspondenceContainer {\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  height: 100%;\n\n  background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export var correspondenceContainer = `correspondenceContainer__mJ2ze`;
export default ___CSS_LOADER_EXPORT___;
